module.exports = __webpack_public_path__ + "static/media/logo-urbes.35d4e64c.png";